import { jsxs as W, jsx as y } from "react/jsx-runtime";
import j, { useEffect as B, useState as z, useCallback as D, useRef as M } from "react";
const $ = {
  dev: "https://grafana-faro-collector.dev.0hash.com/collect",
  cert: "https://grafana-faro-collector.cert.zerohash.com/collect",
  prod: "https://grafana-faro-collector.zerohash.com/collect",
  "eu-cert": "https://grafana-faro-collector.cert.zerohash.eu/collect",
  "eu-prod": "https://grafana-faro-collector.zerohash.eu/collect",
  sandbox: "https://grafana-faro-collector.cert.zerohash.com/collect",
  production: "https://grafana-faro-collector.zerohash.com/collect"
}, V = (e) => {
  if (!e || typeof e != "string")
    return null;
  const t = e.split(".");
  if (t.length < 2)
    return null;
  try {
    const o = t[1].replace(/-/g, "+").replace(/_/g, "/"), r = o + "===".slice(0, (4 - o.length % 4) % 4), a = typeof atob < "u" ? atob(r) : Buffer.from(r, "base64").toString("utf-8"), c = JSON.parse(a)?.payload?.region;
    if (typeof c != "string")
      return null;
    const n = c.toLowerCase();
    return n === "us" || n === "eu" ? n : null;
  } catch {
    return null;
  }
}, I = (e, t) => V(t) !== "eu" ? e : e === "cert" ? "eu-cert" : e === "prod" ? "eu-prod" : e, P = (e) => {
  if (!e || typeof e != "string")
    return {};
  const t = e.split(".");
  if (t.length < 2)
    return {};
  try {
    const o = t[1].replace(/-/g, "+").replace(/_/g, "/"), r = o + "===".slice(0, (4 - o.length % 4) % 4), a = typeof atob < "u" ? atob(r) : Buffer.from(r, "base64").toString("utf-8"), i = JSON.parse(a), c = i?.payload ?? {}, n = (s) => typeof s == "string" && s.length > 0 ? s : void 0;
    return {
      participantCode: n(c.participant_code),
      platformName: n(c.platform_name),
      platformCode: n(i.platform_code),
      region: n(c.region)
    };
  } catch {
    return {};
  }
}, F = (e, t, o) => {
  const r = I(t, o);
  return e[r] ?? e[t] ?? e.prod;
}, J = (e, t, o) => {
  const r = I(t, o);
  return e[r] ?? e[t];
}, O = () => {
}, H = () => {
  const e = new Uint8Array(8);
  return globalThis.crypto.getRandomValues(e), Array.from(e, (t) => t.toString(16).padStart(2, "0")).join("");
}, K = (e, t) => {
  const o = H(), r = globalThis.__ZH_WEB_SDK_VERSION__, a = {};
  e.claims.participantCode && (a.participant_code = e.claims.participantCode), e.claims.platformName && (a.platform_name = e.claims.platformName), e.claims.platformCode && (a.platform_code = e.claims.platformCode), e.claims.region && (a.region = e.claims.region), r && (a.zh_web_sdk_version = r);
  const i = {
    meta: {
      app: { name: e.appName, version: t ?? "unknown", environment: e.env },
      session: { id: o, attributes: a },
      browser: typeof navigator < "u" ? { userAgent: navigator.userAgent } : void 0,
      page: typeof window < "u" ? { url: window.location.origin } : void 0
    },
    logs: [
      {
        message: `Failed to load the script for ${e.webComponentTag} from ${e.env} environment.`,
        level: "error",
        timestamp: (/* @__PURE__ */ new Date()).toISOString(),
        context: {
          web_component: e.webComponentTag,
          script_url: e.scriptUrl,
          reason: e.reason,
          tried_fallback: String(e.triedFallback),
          elapsed_ms: String(e.elapsedMs)
        }
      }
    ]
  };
  return { sessionId: o, payload: i };
}, G = (e, t, o) => {
  if (!e || typeof fetch > "u")
    return;
  const { sessionId: r, payload: a } = K(t, o);
  try {
    fetch(e, {
      method: "POST",
      headers: { "Content-Type": "application/json", "x-faro-session-id": r },
      body: JSON.stringify(a),
      keepalive: !0
    }).catch(() => {
    });
  } catch {
  }
}, Z = (e) => {
  const { webComponentTag: t, appName: o, appVersion: r, scriptUrls: a, fallbackScriptUrls: i, collectorUrls: c, env: n, jwt: s, timeoutMs: u = 15e3, onLoad: _, onError: m } = e;
  if (typeof document > "u")
    return O;
  const g = `${t}-script-${n}`;
  if (customElements.get(t) || document.getElementById(g))
    return O;
  const S = P(s), v = e.report ?? ((d) => G(c && J(c, n, s), d, r));
  let f = !1, x = 0, w;
  const R = () => {
    w !== void 0 && clearTimeout(w);
  }, C = (d, h, l) => {
    if (f)
      return;
    const U = Math.round(performance.now() - x), T = {
      webComponentTag: t,
      appName: o,
      env: n,
      scriptUrl: h,
      reason: d,
      triedFallback: l,
      elapsedMs: U,
      claims: S
    };
    v(T);
    const k = l ? void 0 : F(i ?? {}, n, s);
    if (k && k !== h) {
      E(k, !0);
      return;
    }
    f = !0, R(), document.getElementById(g)?.remove(), m?.(T);
  }, E = (d, h) => {
    R(), x = performance.now();
    const l = document.createElement("script");
    l.id = g, l.src = d, l.type = "module", l.async = !0, l.onload = () => {
      setTimeout(() => {
        f || (customElements.get(t) ? (f = !0, R(), _?.()) : C("not-defined", d, h));
      }, 0);
    }, l.onerror = () => C("network", d, h), w = setTimeout(() => C("timeout", d, h), u), document.getElementById(g)?.remove(), document.head.appendChild(l);
  }, N = F(a, n, s);
  return N ? (E(N, !1), () => {
    f = !0, R();
  }) : O;
}, p = {
  local: "http://localhost:5173",
  dev: "https://sdk-cdn.dev.0hash.com",
  cert: "https://sdk-cdn.cert.zerohash.com",
  prod: "https://sdk-cdn.zerohash.com",
  "eu-cert": "https://sdk-cdn.cert.zerohash.eu",
  "eu-prod": "https://sdk-cdn.zerohash.eu"
}, q = (e, t, o = {}) => {
  const { eu: r = !1, legacyAliases: a = !1, local: i = p.local } = o, c = (s) => `${s}/${e}/${t}`, n = {
    local: c(i),
    dev: c(p.dev),
    cert: c(p.cert),
    prod: c(p.prod)
  };
  return a && (n.sandbox = c(p.cert), n.production = c(p.prod)), r && (n["eu-cert"] = c(p["eu-cert"]), n["eu-prod"] = c(p["eu-prod"])), n;
};
var L;
(function(e) {
  e.NETWORK_ERROR = "network_error", e.AUTH_ERROR = "auth_error", e.NOT_FOUND_ERROR = "not_found_error", e.VALIDATION_ERROR = "validation_error", e.SERVER_ERROR = "server_error", e.CLIENT_ERROR = "client_error", e.UNKNOWN_ERROR = "unknown_error";
})(L || (L = {}));
const b = {
  evergreen: "#00381D",
  green: "#CCFFD0",
  offBlack: "#1C1B1C",
  grayLight: "#EBEBE9"
}, Q = ({ onRetry: e }) => W("div", { role: "alert", style: {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",
  maxWidth: "360px",
  margin: "0 auto",
  padding: "32px 24px",
  textAlign: "center",
  fontFamily: "inherit",
  color: b.offBlack,
  background: "#FFFFFF",
  border: `1px solid ${b.grayLight}`,
  borderRadius: "12px"
}, children: [y("svg", { width: "32", height: "32", viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true", children: y("path", { d: "M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z", stroke: b.evergreen, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }), y("p", { style: { margin: 0, fontSize: "16px", fontWeight: 600 }, children: "Something went wrong" }), y("p", { style: { margin: 0, fontSize: "14px", opacity: 0.75 }, children: "We couldn't load this content. Please check your internet connection and try again." }), y("button", { type: "button", onClick: e, style: {
  marginTop: "8px",
  padding: "8px 20px",
  fontSize: "14px",
  fontWeight: 600,
  fontFamily: "inherit",
  color: b.green,
  background: b.evergreen,
  border: "none",
  borderRadius: "8px",
  cursor: "pointer"
}, children: "Try again" })] }), X = (e, t) => {
  B(() => {
    const o = e.current;
    if (o)
      for (const [r, a] of Object.entries(t))
        a !== void 0 && (o[r] = a);
  });
}, Y = (e) => {
  const { webComponentTag: t, appName: o, appVersion: r, scriptUrls: a, fallbackScriptUrls: i, collectorUrls: c, env: n, jwt: s, timeoutMs: u } = e, [_, m] = z(!1), [g, S] = z(0);
  B(() => (m(!1), Z({
    webComponentTag: t,
    appName: o ?? t,
    appVersion: r,
    scriptUrls: a,
    fallbackScriptUrls: i,
    collectorUrls: c ?? $,
    env: n,
    jwt: s,
    timeoutMs: u,
    onError: () => m(!0)
  })), [
    t,
    o,
    r,
    a,
    i,
    c,
    n,
    s,
    u,
    g
  ]);
  const v = D(() => S((f) => f + 1), []);
  return { loadFailed: _, retry: v };
}, ee = q("fiat-withdrawals-web", "index.js"), A = "zerohash-fiat-withdrawals", re = ({
  jwt: e,
  env: t = "prod",
  theme: o,
  onCompleted: r,
  onError: a,
  onClose: i,
  onLoaded: c,
  onEvent: n,
  ...s
}) => {
  const u = M(null);
  X(u, { theme: o, onCompleted: r, onError: a, onClose: i, onLoaded: c, onEvent: n });
  const { loadFailed: _, retry: m } = Y({
    webComponentTag: A,
    scriptUrls: ee,
    env: t,
    jwt: e
  });
  return _ ? /* @__PURE__ */ y(Q, { onRetry: m }) : j.createElement(A, {
    ref: u,
    jwt: e,
    env: t,
    theme: o,
    ...s
  });
};
export {
  re as FiatWithdrawals
};
